import React, { useEffect } from 'react';
import { Select } from '@appd/uik';
import { toValueIndexes } from '../../utils';
import { CSSProperties } from 'react';

interface DashifySelectProps<T> {
  label: string;
  value?: (T | number)[]; // Allow both T and number types
  multiple?: boolean;
  showOptional?: boolean;
  onChange: (value: (T | number)[]) => void; // Handle changes for an array of type T or number
  options: { value: T; label: string }[]; // Ensure options use generic type T for value
  placeholder?: string;
  className: string;
  style?: CSSProperties;
  onOptionsChange?: (options: { value: T; label: string }[]) => void; // Adjusted to use generic type T
}

export const DashifySelect = <T extends string | number>({
  label,
  value,
  onChange,
  options = [],
  multiple = true,
  showOptional = false,
  placeholder = 'Select a value',
  className,
  style,
  onOptionsChange,
}: DashifySelectProps<T>) => {
  
  const valueIndexes = toValueIndexes(options, value ?? []); // always convert to indexes as sometimes the values can also be numbers

  useEffect(() => {
    if (onOptionsChange) {
      onOptionsChange(options);
    }
  }, [JSON.stringify(options), onOptionsChange]);

  return (
    <Select.Searchable
      multiple={multiple}
      value={valueIndexes}
      onChange={onChange}
      label={label}
      showOptional={showOptional}
      placeholder={placeholder}
      className={className}
      style={style}
    >
      {options.map(option => (
        <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
      ))}
    </Select.Searchable>
  );
};
